module.exports = __webpack_public_path__ + "static/img/知识付费@2x2.c4a3d07a.png";